import { useCallback, useEffect } from 'react';
import { Metrics } from '../../utils/metrics';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TrackedButton } from 'growth-payments-core/usage-tracker/components/Button';
import { events } from 'growth-payments-core/usage-tracker/events';
import { EnrollmentFlowType } from '../../types';
import { useQueryStringState } from 'growth-payments-core/query-string/useQueryStringState';
import CelebrationModalV2 from './CelebrationModalV2';
import TrackRender from 'growth-payments-core/usage-tracker/TrackRender';
import { usePaymentsEnrollmentUtilitiesContext } from '../../context/PaymentsEnrollmentUtilitiesContext';
import { track } from 'growth-payments-core/usage-tracker/track';
import { getCommerceHomeUrl } from 'growth-payments-core/urls/urls';
import { navigateTo } from 'growth-payments-core/urls/utils';
import { addSuccessAlert } from 'growth-payments-core/alerts';
import { useHasSeenUseCasesModal } from '../../hooks/useHasSeenUseCasesModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const TEST_IDS = {
  PRE_APPROVAL_SUCCESS_MODAL_PRIMARY_BUTTON: 'pre-approval-success-modal-primary-button'
};
const PreApprovedApplicationSuccessModalV2 = ({
  onClose,
  shouldReloadOnEnrollmentComplete = true
}) => {
  const {
    currentEnrollmentFlow,
    businessTypeDetails,
    location
  } = usePaymentsEnrollmentUtilitiesContext();
  const [, setCurrentEnrollmentFlow] = useQueryStringState('paymentsEnrollment', EnrollmentFlowType.processorPicker);
  const {
    hasSeenUseCasesModal
  } = useHasSeenUseCasesModal();
  const handleClick = useCallback(() => {
    setCurrentEnrollmentFlow(null);
    if (shouldReloadOnEnrollmentComplete) {
      const url = !hasSeenUseCasesModal ? `${getCommerceHomeUrl()}?modal=useCases` : getCommerceHomeUrl();
      navigateTo(url);
    } else {
      onClose();
    }
  }, [setCurrentEnrollmentFlow, shouldReloadOnEnrollmentComplete, onClose, hasSeenUseCasesModal]);
  const {
    businessType,
    businessStructure
  } = businessTypeDetails;
  useEffect(() => {
    addSuccessAlert({
      title: 'preApprovedApplicationSuccessModal.successAlertTitle',
      message: 'preApprovedApplicationSuccessModal.successAlertMessage'
    });
  }, [currentEnrollmentFlow]);
  useEffect(() => {
    Metrics.counter('stripe-success-modal-viewed', {
      businessType: businessType || '',
      businessStructure: businessStructure || ''
    }).increment();
  }, [businessStructure, businessType]);
  const renderCta = useCallback(() => {
    const primaryCtaTrackingAction = 'goToCommerceOverviewButtonClicked';
    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(TrackedButton, {
        event: events.paymentSettingsInteraction,
        trackingProperties: {
          action: primaryCtaTrackingAction,
          location: 'pre-approved-application-success-modal'
        },
        "data-test-id": TEST_IDS.PRE_APPROVAL_SUCCESS_MODAL_PRIMARY_BUTTON,
        use: "primary",
        onClick: handleClick,
        children: shouldReloadOnEnrollmentComplete ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.primaryCta"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.continue"
        })
      })
    });
  }, [handleClick, shouldReloadOnEnrollmentComplete]);
  return /*#__PURE__*/_jsx(CelebrationModalV2, {
    currentEnrollmentFlow: currentEnrollmentFlow,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "preApprovedApplicationSuccessModal.header"
    }),
    subTitle: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "preApprovedApplicationSuccessModal.subTitle"
    }),
    bodyContent: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TrackRender, {
        event: events.growthPaymentsPageView,
        properties: {
          screen: 'kyc-pre-approval-success-modal',
          location
        }
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "preApprovedApplicationSuccessModal.body"
        })
      }), shouldReloadOnEnrollmentComplete && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "preApprovedApplicationSuccessModal.goToCommerceOverview"
      })]
    }),
    note: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "preApprovedApplicationSuccessModal.note"
    }),
    testID: "kyc-success-modal",
    onClose: () => {
      track(events.paymentSettingsInteraction, {
        action: 'cancelButtonClicked',
        location: 'pre-approved-application-success-modal'
      });
      handleClick();
    },
    primaryCTA: renderCta()
  });
};
export default PreApprovedApplicationSuccessModalV2;